import * as React from "react";
import type { SVGProps } from "react";

interface TouchbackProps extends SVGProps<SVGSVGElement> {
  cancelled?: boolean;
}
const Touchback = ({ cancelled = false, ...props }: TouchbackProps) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
    <g>
    <g fill="none" fillRule="evenodd">
      <path
        fill="#FFF"
        fillRule="nonzero"
        d="M4.858 3.839C.493 7.415-1.191 12.882 1.45 16.18c2.651 3.313 8.312 2.78 12.685-.802 4.365-3.576 6.048-9.043 3.408-12.342C14.892-.276 9.23.256 4.858 3.839m.878 1.071c3.846-3.15 8.648-3.603 10.724-1.008s.642 7.254-3.204 10.405C9.41 17.46 4.608 17.91 2.532 15.315S1.889 8.062 5.736 4.91"
      />
      <path
        fill="#FFF"
        fillRule="nonzero"
        d="M5.736 4.91c3.846-3.15 8.648-3.603 10.724-1.008s.642 7.254-3.204 10.405C9.41 17.46 4.608 17.91 2.532 15.315S1.889 8.062 5.736 4.91"
      />
      <path
        fill="#000"
        d="M1.947 9.085q1.714 2.964 2.783 4.301 1.07 1.339 3.543 3.615l-2.744.687-4.341-5.825zm15.066 1.022q-1.714-2.964-2.783-4.302-1.07-1.338-3.542-3.614l2.743-.687 4.342 5.825z"
      />
      <path
        fill="#000"
        fillRule="nonzero"
        d="M12.134 4.75a.515.515 0 0 1-.111.72l-.58.427-.316.234.377.432a.396.396 0 0 1-.598.52l-.414-.477q-.343.258-.657.5l.39.447a.396.396 0 0 1-.598.52l-.42-.481q-.354.278-.664.53l.403.46a.396.396 0 0 1-.597.52l-.416-.477q-.146.124-.278.24l-.135.118-.181.162.4.43a.396.396 0 1 1-.578.54l-.405-.437q-.328.305-.658.623l.424.443a.396.396 0 0 1-.57.55l-.42-.44q-.404.402-.812.824a.515.515 0 1 1-.74-.715q.42-.435.838-.848l-.42-.432a.396.396 0 0 1 .569-.55l.416.428q.336-.324.671-.636l-.42-.448a.396.396 0 0 1 .579-.54l.425.454.199-.178.3-.261.12-.105-.377-.436a.396.396 0 0 1 .597-.52l.391.452q.31-.25.664-.53l-.374-.43a.396.396 0 0 1 .598-.52l.402.465q.315-.242.657-.5l-.378-.435a.396.396 0 1 1 .597-.52l.416.479q.46-.343.964-.713a.515.515 0 0 1 .72.111"
      />
      <path
        fill="#000"
        fillRule="nonzero"
        d="M5.234 4.298C9.381.9 14.674.403 17.08 3.408c2.4 2.997.822 8.117-3.32 11.512-4.148 3.398-9.44 3.895-11.846.89-2.398-2.997-.822-8.118 3.321-11.512Zm11.227-.396C14.384 1.307 9.582 1.76 5.736 4.91 1.889 8.062.455 12.72 2.532 15.315s6.878 2.144 10.725-1.008c3.846-3.151 5.281-7.81 3.204-10.405"
      />
      <g fillRule="nonzero">
        <path
          fill="#FFF"
          d="M16 8.25a7.75 7.75 0 1 0 0 15.5 7.75 7.75 0 0 0 0-15.5"
        />
        <path fill="#60B100" d="M16 9a7 7 0 1 1 0 14 7 7 0 0 1 0-14" />
      </g>
      <path
        fill="#FFF"
        d="M16.828 19.564a1 1 0 0 1-1.414 1.414l-4.242-4.242a1 1 0 0 1-.292-.649v-.175a1 1 0 0 1 .292-.648l4.242-4.243a1 1 0 0 1 1.414 1.415L14.264 15h4.962a4 4 0 0 1 3.996 3.82 7.8 7.8 0 0 1-1.937 2.848 1 1 0 0 1-.06-.335V19a2 2 0 0 0-2-2h-4.961z"
      />
    </g>
        {cancelled && (
        <rect
          width="25"
          height="2.5"
          x="-.494"
          y="10.746"
          fill="#000"
          fillRule="evenodd"
          stroke="#FFF"
          rx="1"
          transform="rotate(-45 12.006 11.996)"
        />
      )}
    </g>
  </svg>
);
export default Touchback;
